'use strict';
var parent = require('../../es/symbol/dispose');

module.exports = parent;
